import { Skeleton, View } from "@/components/ui";
import { Typography } from "../../typography";
import { WorkerAvatar as WorkerAvatarComponent } from "@/components/shared/worker-avatar";

export function WorkerAvatar({
  fullName,
  avatarUrl,
  loading,
}: {
  fullName: string;
  avatarUrl: string | null;
  loading?: boolean;
}) {
  return (
    <View className="flex flex-row items-center gap-1">
      <WorkerAvatarComponent src={avatarUrl} size={36} />
      {loading ? (
        <Skeleton className="mr-4 h-3 w-[200px]" />
      ) : (
        <Typography
          variant="body-sm"
          className="line-clamp-1 overflow-hidden whitespace-nowrap"
        >
          {fullName}
        </Typography>
      )}
    </View>
  );
}
